/**
 * DOM Ready Utility
 * Helper for executing code when the DOM is ready
 *
 * @package StandOut
 * @since 2.0.0
 */
/**
 * Execute a callback when the DOM is ready
 *
 * @param callback - Function to execute when DOM is ready
 *
 * @example
 * onDomReady(() => {
 *     initNavigation()
 * })
 */
export const onDomReady = (callback) => {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", callback, { once: true });
    }
    else {
        callback();
    }
};
/**
 * Execute a callback when the page is fully loaded (including images)
 *
 * @param callback - Function to execute when page is fully loaded
 */
export const onPageLoad = (callback) => {
    if (document.readyState === "complete") {
        callback();
    }
    else {
        window.addEventListener("load", callback, { once: true });
    }
};
